<script>
	import axios from 'axios';
	import Router from 'svelte-spa-router';
import Pagina from './pagina.svelte';
	let routes = {
		'/:id':Pagina
	}
</script>

<Router {routes} />